import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Button } from 'fw/components';
import { NaicsCodeCategoryAuto } from 'areas/shared/controls';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import * as API from 'modules/app/API';

export const searchCompanyLoader = () => {
	return {
		url: API.Search.url('/suggest'),
		params: {
			type: 'vob'
		}
	}
}

export const searchVeteranLoader = () => {
	return {
		url: API.Search.url('/suggest'),
		params: { type: 'vobOwner' }
	}
}

export const handleAddAnotherNAIC = (f, updater) => {
	let form = f;
	form.nAICSCodes.push({ value: "", label: "" });
	updater(form);
}

export const handleRemoveNAIC = (index, f, updater) => {
	let form = f;
	form.nAICSCodes.splice(index, 1);
	updater(form);
}

export const handleNAICChange = (item, index, f, updater) => {
	let form = f;
	form.nAICSCodes[index] = item;
	updater(form);
}

export const renderNAICs = (form, updater) => {
	return form.nAICSCodes.map((item, index) => (
		<Row key={index} style={{ marginBottom: 10 }}>
			<Col md={form.nAICSCodes.length === 1 ? 12 : 11}>
				<NaicsCodeCategoryAuto
					value={item ? item.value : null}
					text={item ? item.label : null}
					placeholder='Search NAICS Code...'
					onChange={e => handleNAICChange(e, index, form, updater)}
					maxLength={6}
				/>
			</Col>
			{form.nAICSCodes.length > 1 ?
				<Col md={1} style={{ marginTop: 0, marginLeft: -15, paddingLeft: 0, textAlign: "left" }}>
					<Button type="button" bsStyle="link" onClick={() => handleRemoveNAIC(index, form, updater)} title="Remove NAICS Code">
						<FontAwesomeIcon icon={faTrashAlt} size="lg" color="black" />
					</Button>
				</Col> : null
			}
		</Row>
	));
};


// WEBPACK FOOTER //
// ./src/areas/shared/helpers/ConnectToVOBSearchHelpers.js